import { PayoutRuleType } from '@common-fe/common-fe';
import { create } from 'zustand';

export interface ProcessingRuleTierUpdate {
  tierId: string;
  payoutRuleType: PayoutRuleType;
  isLockPurse?: boolean;
  planIds?: string[];
}

interface ProcessingRuleTiersState {
  tiers: ProcessingRuleTierUpdate[];
  // Upsert a tier by its id: replaces the matching entry or appends a new one.
  setTier: (tier: ProcessingRuleTierUpdate) => void;
  resetTiers: () => void;
}

export const useProcessingRuleTiersStore = create<ProcessingRuleTiersState>((set) => ({
  tiers: [],
  setTier: (tier) =>
    set((state) => {
      const exists = state.tiers.some((item) => item.tierId === tier.tierId);
      return {
        tiers: exists
          ? state.tiers.map((item) => (item.tierId === tier.tierId ? tier : item))
          : [...state.tiers, tier],
      };
    }),
  resetTiers: () => set({ tiers: [] }),
}));
